import { Mission } from '../../lib/types/models/mission/mission'
import { MissionInput, MissionTimeInput } from '../../lib/types/models/mission/mission-input'
import { UpdateInput } from '../../lib/types/utils'
import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export type UpdateMissionInput = UpdateInput<MissionInput> & {
  times?: MissionTimeInput[]
}

export function updateMission(data: UpdateMissionInput): Promise<Mission> {
  const { id, ...rest } = data
  return restApiClient
    .url(constructApiUrl(API.missions.update.url, { id }))
    .patch<Mission>({ ...rest })
}
